import { useContext, useMemo } from 'react';
import { AppContext } from '../../index';

export type ExportAssetType =
  | 'compute'
  | 'field'
  | 'dcs_plc'
  | 'network'
  | 'application'
  | 'asset_management'
  | 'env'
  | 'analyzer_management'
  | 'control'
  | 'virtualization';

const exportAssetTypeToPermissionType = (type: ExportAssetType) => {
  const normalizedType = type.replace(/_/g, '');
  switch (type) {
    case 'field':
    case 'env':
    case 'compute':
    case 'network':
    case 'dcs_plc':
      return `${normalizedType}asset`;
    case 'analyzer_management':
    case 'asset_management':
    case 'virtualization':
    case 'control':
      return `${normalizedType}application`;
    case 'application':
      return 'securityapplication';
    default:
      return normalizedType;
  }
};

export default function usePermissionsForType(
  type: ExportAssetType,
  permissionPrefix: string | string[] = ['add', 'view', 'change', 'delete']
) {
  const app = useContext(AppContext);
  const prefixes = useMemo(
    () =>
      Array.isArray(permissionPrefix) ? permissionPrefix : [permissionPrefix],
    [permissionPrefix]
  );
  return useMemo(
    () =>
      app.permissionsWithView.flatMap(perm =>
        prefixes.reduce((codenames: string[], prefix) => {
          if (
            perm.codename?.includes(`${prefix}_`) &&
            perm.codename?.includes(exportAssetTypeToPermissionType(type))
          ) {
            codenames.push(perm.codename);
          }
          return codenames;
        }, [])
      ),
    [app.permissionsWithView, prefixes, type]
  );
}
